import BranchFundingSourceHolidayComponent from './branch_funding_source_holiday.component';
import BranchFundingSourceHolidayAll from './all'
import BranchFundingSourceHolidayCreate from './create'
import BranchFundingSourceHolidayEdit from './edit'

let BranchFundingSourceHolidayModule = angular.module('branchFundingSourceHoliday', [
    BranchFundingSourceHolidayAll,
    BranchFundingSourceHolidayCreate,
    BranchFundingSourceHolidayEdit
])

    .component('branchFundingSourceHoliday', BranchFundingSourceHolidayComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider
            .state('branch-funding-source-holiday.all', {
                url: '/all/:page',
                component: 'branchFundingSourceHolidayAll',
                data: {
                    requireACL: 'setting-branch-funding-source-holiday.view'
                }
            })

            .state('branch-funding-source-holiday.create', {
                url: '/create',
                component: 'branchFundingSourceHolidayCreate',
                data: {
                    requireACL: 'setting-branch-funding-source-holiday.create'
                }
            })

            .state('branch-funding-source-holiday.edit', {
                url: '/edit/:id',
                component: 'branchFundingSourceHolidayEdit',
                data: {
                    requireACL: 'setting-branch-funding-source-holiday.edit'
                }
            })
    })

    .name;

export default BranchFundingSourceHolidayModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/index.js